import Point from '../../Utility/Point';
import GameObject, { GameObjectEvent } from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Container from '../Container';
import Interactable from '../../Component/Interactable';
import TransformComponent from '../../Component/Transform';
import AnimationComponent from '../../Component/Animation';
import Renderable from '../../Component/Renderable';
import Game from '../../Game';
import { GameActions } from '../../State/Game/GameActions';
import SpriteComponent from '../../Component/Render/Sprite';
import { IFriendData } from '../../Player/PlayerProperty/Social/IPlayerSocialData';
import { StartAnimation } from '../../System/Animation/AnimationHelper';
import { Easing } from '@tweenjs/tween.js';
import { Random } from '../../Utility/Random';
import { ContextType } from '../../State/Game/ContextType';
import { IGameState } from '../../State/Game/IGameState';

export default class FriendIcon extends GameObject {
    public friendId: string;
    public placement: number;

    public onCreate(params: {
        avatarTexture: string;
        isClientPlayer: boolean;
        friendId: string;
        placement: number;
    }): void {
        this.name = `friend_icon_${params.friendId}`;
        this.friendId = params.friendId;
        this.placement = params.placement;

        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);

        const iconContainer = GameObject.Instantiate(Container, {
            name: 'icon_container',
            position: new Point(0, -18),
        });
        this.addChild(iconContainer);

        const avatarSprite: Sprite = GameObject.Instantiate(Sprite, {
            name: 'avatar_img',
            position: new Point(0, -53),
            texture: 'no_avatar_pink',
            anchor: new Point(0.5, 1),
            width: 42,
            height: 42,
        });
        iconContainer.addChild(avatarSprite);

        const coinSprite: Sprite = GameObject.Instantiate(Sprite, {
            name: 'coin',
            position: new Point(30, -95),
            texture: 'plus_coins_avatar',
            anchor: new Point(0.5, 0.5),
        });

        const iconSprite: Sprite = GameObject.Instantiate(Sprite, {
            name: 'icon_sprite',
            texture: 'avatar_shadowless_2',
            anchor: new Point(0.5, 1),
        });
        iconSprite.addComponent(Interactable, {
            enabled: false,
            buttonMode: true,
        });
        iconSprite.on(GameObjectEvent.SELECTED, this.onSend.bind(this));
        iconSprite.addChild(coinSprite);
        iconContainer.addChild(iconSprite);

        iconContainer.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'FriendIconIdle',
        });

        const state: IGameState = Game.store.getState();
        const friendData = state.playerState.social.friendData.find(
            (data: IFriendData) => data.playerId === this.friendId
        );
        this.enableSend(!friendData || friendData.giftCooldown === null);

        if (state.playerState.settings.cinematicMode) {
            this.getComponent<Renderable>(Renderable).visible = false;
        }
    }

    public set avatar(value: string) {
        const avatarSprite: GameObject = this.findChildByName('avatar_img');

        avatarSprite.getComponent(SpriteComponent).texture = value === 'no_avatar' ? 'no_avatar_pink' : value;
        StartAnimation(this, 'Scale', {
            startScale: Point.Zero,
            endScale: Point.One,
            duration: 250,
            easing: Easing.Back.Out,
            delay: Random.value(0, 500) * (this.placement + 1),
        });
    }

    public enableSend(enabled: boolean): void {
        const coinSprite: GameObject = this.findChildByName('coin');
        coinSprite.getComponent<Renderable>(SpriteComponent).visible = enabled;

        const iconSprite: GameObject = this.findChildByName('icon_sprite');
        iconSprite.getComponent(Interactable).enabled = enabled;
        iconSprite.getComponent(Interactable).buttonMode = enabled;

        if (enabled) {
            iconSprite.on(GameObjectEvent.SELECTED, this.onSend.bind(this));
        } else {
            iconSprite.off(GameObjectEvent.SELECTED);
        }
    }

    private onSend(): void {
        GameActions.setContext(ContextType.SEND_FRIEND_GIFT, {
            friendId: this.friendId,
            placement: 'SagaMap',
        });
        this.enableSend(false);
    }
}
